export default "__VITE_ASSET__290ebea7__"